import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PageHeader from '@common/PageHeader';
import IFrame from '@common/IFrame';
import Button, { IconButton } from '@common/Button';

import SmallProjects from './SmallProjects';

import ProjectTemplate from './ProjectTemplate';
import { ProjectLinks, ProjectPreview, Tags } from './ProjectTemplate.style';

const ProjectsWrapper = styled.section`
  ${(props) => props.theme.spacing.sectionBottom};
`;

const Projects = () => {
  let projects;

  try {
    projects = useStaticQuery(
      graphql`
        query {
          allMarkdownRemark(
            filter: { fields: { posttype: { eq: "case-studies" } } }
            sort: { fields: fields___fileIndex, order: ASC }
          ) {
            edges {
              node {
                id
                frontmatter {
                  demo
                  excerpt
                  iframe
                  src
                  title
                }
                fields {
                  slug
                }
              }
            }
          }
        }
      `
    );
  } catch (error) {
    console.error('Error fetching project data:', error);
    return (
      <ProjectsWrapper id="projects" style={{ marginBottom: 100 }}>
        <PageHeader>Side Projects</PageHeader>
        <p>Failed to load projects. Please try again later.</p>
      </ProjectsWrapper>
    );
  }

  if (!projects || !projects.allMarkdownRemark || !projects.allMarkdownRemark.edges.length) {
    return (
      <ProjectsWrapper id="projects" style={{ marginBottom: 100 }}>
        <PageHeader>Side Projects</PageHeader>
        <p>No projects found. Please check back later.</p>
      </ProjectsWrapper>
    );
  }

  return (
    <ProjectsWrapper id="projects" style={{ marginBottom: 100 }}>
      <PageHeader>Side Projects</PageHeader>

      {projects.allMarkdownRemark.edges.map(({ node }) => (
        <ProjectTemplate
          key={node.id}
          title={node.frontmatter.title || 'Untitled Project'}
          desc={node.frontmatter.excerpt || 'No description available.'}
          links={
            <ProjectLinks>
              {node.fields.slug && (
                <Button as={Link} to={node.fields.slug}>
                  Case Study
                </Button>
              )}
              {node.frontmatter.demo && (
                <Button target="__blank" as="a" href={node.frontmatter.demo}>
                  Live Demo
                </Button>
              )}
              {node.frontmatter.src && (
                <IconButton
                  label="github"
                  icon={['fab', 'github']}
                  href={node.frontmatter.src}
                />
              )}
            </ProjectLinks>
          }
          preview={
            <ProjectPreview>
              {node.frontmatter.iframe ? (
                <IFrame
                  livedemo={!!node.frontmatter.iframe.match('codepen')}
                  src={node.frontmatter.iframe}
                />
              ) : (
                <p>Preview not available</p>
              )}
              <Tags>
                <FontAwesomeIcon icon={['fab', 'js']} />
                <FontAwesomeIcon icon={['fab', 'html5']} />
                <FontAwesomeIcon icon={['fab', 'css3']} />
              </Tags>
            </ProjectPreview>
          }
        />
      ))}

      <SmallProjects />
    </ProjectsWrapper>
  );
};

export default Projects;
